module.exports = __webpack_public_path__ + "static/media/logo_styling_xs.3ad6cc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/Application/scenes/Site/Body/scenes/Portfolio/Posts/Post/IconType/img/logo_styling_xs.png
// module id = 486
// module chunks = 0